function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

import React, { Component } from "react";

var RawHTMLField = /*#__PURE__*/function (_Component) {
  _inheritsLoose(RawHTMLField, _Component);

  function RawHTMLField(props) {
    var _this;

    _this = _Component.call(this, props) || this;
    _this.state = _extends({}, props, {
      __html: props.uiSchema["ui:options"] ? props.uiSchema["ui:options"].html : "Set the html for this field with the 'ui:options' key in uiSchema."
    });
    return _this;
  }

  var _proto = RawHTMLField.prototype;

  _proto.render = function render() {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      dangerouslySetInnerHTML: this.state
    }));
  };

  return RawHTMLField;
}(Component);

export default RawHTMLField;